export default __webpack_public_path__ + "static/media/2.a8764e29.png";